export default function scrollToTop() {
  const btn = document.querySelector('.scroll-to-top');
  if (!btn) return;

  btn.setAttribute('tabindex', '-1');

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        const threshold = window.innerHeight * 0.5;
        if (window.scrollY > threshold) {
          btn.classList.add('visible');
          btn.removeAttribute('tabindex');
        } else {
          btn.classList.remove('visible');
          btn.setAttribute('tabindex', '-1');
        }
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  btn.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
}
